import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CompanyDocument } from '../types';

type BulkArchiveVariables = {
  documentIds: string[];
  isArchived: boolean;
};

type BulkArchiveResult = {
  documents: CompanyDocument[];
  skippedIds: string[];
};

export const useBulkArchiveCompanyDocuments = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: BulkArchiveResult },
    Error,
    BulkArchiveVariables
  >({
    mutationFn: ({ documentIds, isArchived }) =>
      api.post<BulkArchiveResult>('company-documents/bulk-archive', {
        documentIds,
        isArchived,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-documents'] });
    },
  });

  const bulkArchiveCompanyDocuments = async (documentIds: string[], isArchived: boolean) => {
    const response = await mutateAsync({ documentIds, isArchived });
    return response.data;
  };

  return {
    bulkArchiveCompanyDocuments,
    isLoading,
  };
};
